import { ModuleConfig } from "../../common/types";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

export const config: ModuleConfig = {
  id: "meridian",
  name: "MeridianOne",
  description: "AI-assisted document generation with structured templates and quality checks.",
  startPage: "documents", // Default page for Meridian module
  routes: [
    {
      path: "admin/document-types",
      componentPath:
        "./modules/meridian/views/documentType/DocumentTypesOverview",
      exact: true,
      requiredRole: "admin",
    },
    {
      path: "admin/document-types/new",
      componentPath: "./modules/meridian/views/documentType/ManageDocumentType",
      exact: true,
      requiredRole: "admin",
    },
    {
      path: "admin/document-types/:id",
      componentPath: "./modules/meridian/views/documentType/ManageDocumentType",
      exact: true,
      requiredRole: "admin",
    },
    {
      path: "admin/document-types/:id/test",
      componentPath: "./modules/meridian/views/documentType/TestDocumentType",
      exact: true,
      requiredRole: "admin",
    },
    {
      path: "documents",
      componentPath:
        "./modules/meridian/views/documentGeneration/DocumentOverview",
      exact: true,
      requiredRole: "user",
    },
    {
      path: "documents/new",
      componentPath:
        "./modules/meridian/views/documentGeneration/SelectDocumentType",
      exact: true,
      requiredRole: "user",
    },
    {
      path: "documents/generate/:documentTypeId",
      componentPath:
        "./modules/meridian/views/documentGeneration/GenerateDocument",
      exact: true,
      requiredRole: "user",
    },
    {
      path: "documents/edit/:documentId",
      componentPath:
        "./modules/meridian/views/documentGeneration/GenerateDocument",
      exact: true,
      requiredRole: "user",
    },
    {
      path: "documents/download/:filename",
      componentPath:
        "./modules/meridian/components/documentGeneration/DownloadHandler",
      exact: true,
      requiredRole: "user",
    },
    {
      path: "transcripts",
      componentPath: "./modules/meridian/views/transcripts/TranscriptList",
      exact: true,
      requiredRole: "user",
      requiredFeature: "meridian_transcripts",
    },
    {
      path: "transcripts/new",
      componentPath: "./modules/meridian/views/transcripts/StartTranscript",
      exact: true,
      requiredRole: "user",
      requiredFeature: "meridian_transcripts",
    },
    {
      path: "transcripts/:transcriptId",
      componentPath: "./modules/meridian/views/transcripts/TranscriptDetail",
      exact: true,
      requiredRole: "user",
      requiredFeature: "meridian_transcripts",
    },
    {
      path: "qc",
      componentPath: "./modules/meridian/views/qc/IndependentQC",
      exact: true,
      requiredRole: "user",
      requiredFeature: "meridian_qc",
    },
  ],
  navigation: [
    {
      path: "documents",
      name: "Documents",
      icon: DescriptionIcon,
      requiredRole: "user",
    },
    {
      path: "qc",
      name: "Quality Check",
      icon: FactCheckIcon,
      requiredRole: "user",
      requiredFeature: "meridian_qc",
    },
    {
      path: "transcripts",
      name: "Transcripts",
      icon: RecordVoiceOverIcon,
      requiredRole: "user",
      requiredFeature: "meridian_transcripts",
    },
    // {
    //   path: '/documents/new',
    //   name: 'New Document',
    //   icon: DescriptionIcon,
    //   requiredRole: 'user'
    // },
    {
      path: "admin/document-types",
      name: "Document Types",
      icon: AssignmentIcon,
      requiredRole: "admin",
    },
  ],
};
